import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from './Box';
import { TableCol, TableRow } from './ProductTable';
export const DelayTable = () => {
  const $ = _c(50);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["pricing"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("delayTable.table.1");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("delayTable.table.2");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("delayTable.table.3");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("delayTable.table.4");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("delayTable.table.5");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("delayTable.table.6");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = [t1, t2, t3, t4, t5, t6];
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const tableLabels = t7;
  let t8;
  if ($[20] !== t) {
    t8 = t("delayTable.deferredPayment.1");
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t) {
    t9 = t("delayTable.deferredPayment.2");
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t) {
    t10 = t("delayTable.deferredPayment.3");
    $[24] = t;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t) {
    t11 = t("delayTable.deferredPayment.4");
    $[26] = t;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t) {
    t12 = t("delayTable.deferredPayment.5");
    $[28] = t;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t) {
    t13 = t("delayTable.deferredPayment.6");
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t8 || $[37] !== t9) {
    t14 = [t8, t9, t10, t11, t12, t13];
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
    $[36] = t8;
    $[37] = t9;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  const paymentLabels = t14;
  let t15;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <TableCol />;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t) {
    t16 = t("delayTable.subtitle");
    $[40] = t;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t16) {
    t17 = <TableRow>{t15}<TableCol variant="header" isActive={true}>{t16}</TableCol></TableRow>;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== paymentLabels || $[45] !== tableLabels) {
    t18 = <div className="flex flex-col gap-4">{tableLabels.map((label, i) => <TableRow key={i}><TableCol isActive={true}>{label}</TableCol><TableCol variant="text" isActive={true}>{paymentLabels[i]}</TableCol></TableRow>)}</div>;
    $[44] = paymentLabels;
    $[45] = tableLabels;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t17 || $[48] !== t18) {
    t19 = <Box><div className="flex flex-col gap-6">{t17}{t18}</div></Box>;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  return t19;
};